import React from "react";
import AnnouncementIcon from "../_shared/AnnouncementIcon";
import { TFunction } from "next-i18next";
import styles from "../../styles/components/skills-hub/ClosureNotice.module.scss";

// Shown in place of the category grid while Skills Hub is closed
// (SKILLS_HUB_OPEN in constants/skillsHub.js). Nothing is bookable then, no
// category or class page builds, and everything under /skills-hub redirects
// to this page. Copy comes from the `skills-hub-closed` namespace, which only
// the closed page loads, so an open page never carries "has ended" in the
// translations it ships.
//
// Says only that the classes ended and thanks the reader. Where to go next is
// the SOLS edu card below it, which is the page's main call to action, and the
// invitation to share a memory closes the page in `ShareAMemory`. The tinted
// background keeps this reading as a notice beside that white card.
const ClosureNotice = (props: Props) => {
  const { t } = props;

  return (
    <section className={styles.notice} aria-labelledby="skills-hub-notice">
      <div className={styles.icon}>
        <AnnouncementIcon />
      </div>
      <div className={styles.body}>
        <h2 id="skills-hub-notice">{t("closure-h2")}</h2>
        <p>{t("closure-p1")}</p>
      </div>
    </section>
  );
};

interface Props {
  t: TFunction;
}

export default ClosureNotice;
